export default BaseRouterConfig;

// @ngInject
function BaseRouterConfig($stateProvider) {
  $stateProvider.state('home', {
    url: '/',
    template: '<dmattnt-home></dmattnt-home>',
    data: {label: 'Accueil'}
  }).state('mentions_legales', {
    url: '/mentions-legales',
    template: '<dmattnt-mentions-legales></dmattnt-mentions-legales>'
  });
}



// WEBPACK FOOTER //
// ./src/modules/base/routes.js